











import {mixins} from "vue-class-component";
import {CommonMixin} from "../../services/mixin";
import {Component, Emit, Model, Prop} from "vue-property-decorator";

@Component({
    name: 'ATextareaCustom'
})
export default class extends mixins(CommonMixin){
    @Prop({ type: String, default: "Nhập đầu vào" }) readonly placeholder!: string;
    @Prop({ default: 'default' }) readonly size!: string;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Model('change') readonly val;
    @Emit('change')
    handleChangeVal(val: any) {
        return val;
    }

    @Emit("enter")
    onEnter(evt: any) {
        return evt;
    }

    set valTrue(val: any) {
        this.handleChangeVal(val);
    }

    get valTrue() {
        return this.val;
    }
}
